import { filters, titleFilter } from './filters.js';
import { filtersToData } from '../utils/filtersToData.js';
import paramsToFilters from '../utils/paramsToFilters.js';

/*
    our simple routing functions:

        Update the URL when the filters change,

    or

        Update the filters when the URL changes!
*/
function updateURLFromFilters() {

    const url = new URL(document.location);
    const pathname = url.pathname;

    const params = new URLSearchParams(url.search);

    filters.forEach((filter) => {

        const terms = filter.options;
        const usedTerms = terms.filter((term) => term.checked === true);
        const termIds = usedTerms.map((term) => term.id);

        params.delete(filter.name);

        termIds.forEach((termId) => {

            params.append(
                filter.name,
                termId,
            );

        });

    });

    const filterData = filtersToData(filters);

    if (titleFilter.value) {

        params.set('text', titleFilter.value);

    } else {

        params.delete('text');

    }

    const paramString = params.toString().length ? '?' + params.toString() : '';

    window.history.replaceState({ filters: filterData, text: titleFilter.value }, '', pathname + paramString);

}

function updateFiltersFromUrl(params) {

    if (params instanceof URLSearchParams) {

        paramsToFilters(params);

        const textString = params.get('text');

        if (textString) {

            titleFilter.value = textString;

        }

    }

}

function getReadingModeFromUrl() {

    const url = new URL(document.location);
    const params = new URLSearchParams(url.search);
    const versionMap = {
        Live: 'LIVE',
        Stage: 'DRAFT',
    };
    const stage = params.get('stage') ?? 'Live';
    return Object.prototype.hasOwnProperty.call(versionMap, stage) ? versionMap[stage] : 'LIVE';

}

export const routing = {

    updateURLFromFilters,
    updateFiltersFromUrl,
    getReadingModeFromUrl,

};
